export const namespaced = true;

import cloneDeep from 'lodash/cloneDeep';

export const state = {
  sidebarProgresses: [],
  currentImportProgressId: 0,
};

export const mutations = {
  START_IMPORTING(state) {
    state.sidebarProgresses = cloneDeep(DEFAULT_PROGRESSES);
    state.currentImportProgressId = 1;
  },
  UPDATE_FIRST_PROGRESS_VALUE(state, payload) {
    payload.progress.value = payload.value;
    payload.progress.done = payload.done;
  },
  START_VIEWING_FILE_CONTENT(state) {
    state.currentImportProgressId = 2;
  },
  UPDATE_SECOND_PROGRESS_VALUE(state, payload) {
    payload.progress.value = payload.value;
    payload.progress.done = payload.done;
  },
  START_REVIEWING_STUDENTS(state) {
    state.currentImportProgressId = 3;
  },
  EXIT_IMPORTING(state) {
    state.currentImportProgressId = 0;
  },
  MARK_IMPORTING_WITH_ERROR(state, payload) {
    state.sidebarProgresses.splice(payload.index, 1, payload.progress);
  },
};

export const actions = {
  startImporting({ commit }) {
    commit('START_IMPORTING');
  },
  updatePendingImportProgress({ commit, getters }, payload) {
    var firstProgress = getters.getSidebarProgressById(1);
    if (firstProgress) {
      let data = { value: payload.value, done: payload.done, progress: firstProgress };
      commit('UPDATE_FIRST_PROGRESS_VALUE', data);
    }
    if (payload.done) {
      commit('START_VIEWING_FILE_CONTENT');
    }
  },
  updateReadyImportProgress({ commit, getters }, payload) {
    var secondProgress = getters.getSidebarProgressById(2);
    if (secondProgress) {
      let data = { value: payload.value, done: payload.done, progress: secondProgress };
      commit('UPDATE_SECOND_PROGRESS_VALUE', data);
    }
    if (payload.done) {
      commit('START_REVIEWING_STUDENTS');
    }
  },
  exitImporting({ commit }) {
    commit('EXIT_IMPORTING');
  },
  markImportingWithError({ commit, state, getters }, error) {
    var currentProgress = getters.getCurrentSidebarProgress;
    currentProgress.error = error;
    let payload = {
      index: state.sidebarProgresses.findIndex((item) => item.id === currentProgress.id),
      progress: currentProgress,
    };
    commit('MARK_IMPORTING_WITH_ERROR', payload);
  },
};

export const getters = {
  getSidebarProgressesUpToId: (state) => (id) => {
    return state.sidebarProgresses.filter((field) => field.id <= id);
  },
  getSidebarProgressById: (state) => (id) => {
    return state.sidebarProgresses.find((item) => item.id == id);
  },
  getCurrentSidebarProgress: (state) => {
    return state.sidebarProgresses.find((item) => item.id == state.currentImportProgressId);
  },
  importingInProgress: (state) => {
    return state.currentImportProgressId > 0;
  },
};

const DEFAULT_PROGRESSES = [
  {
    id: 1,
    step: '① Excelファイル取り込み',
    title: '',
    error: '',
    body: '取り込んだ数：',
    value: 0,
    done: false,
  },
  {
    id: 2,
    step: '② 生徒所属登録',
    title:
      '「クリックして一括機能を選択 / 検索」から「生徒の所属を登録」を選択します。登録したい生徒にチェックを入れ、教場やコースを紐づけてください。',
    error: '',
    body: '紐付けが完了した数：',
    value: 0,
    done: false,
  },
  {
    id: 3,
    step: '③ 本登録',
    title: '「本登録」を押して、取り込みリストの生徒をAAA+に登録します。',
    error: '',
    body: '登録完了した数：',
    value: 0,
    done: false,
  },
];
